import { CrudAccess, EmployeeIdentityResponse, EmployeeModel, UpdateRosterEmployeeRequest } from "@herbjoy/apex-api-models";
import { IFormController } from "angular";
import { StateService } from "angular-ui-router";
import { EventEmitter } from "../../../common/components/event-emitter";
import { EmployeeService } from "../../../core/services";
import { UtilityService } from "../../../core/services/utility.service";
import templateUrl from "./employee-account-editor.component.html";

export const EmployeeAccountEditorComponent = {
    templateUrl,
    require: {
        employeeForm: "^^?form"
    },
    bindings: {
        employee: "<",
        identity: "<",
        roleAccess: "<",
        showPasswordEditor: "<",
        sendPasswordReset: "&onSendPasswordReset",
        separateEditPages: "<"
    },
    controller: class {
        //@Input
        employeeForm: IFormController;
        //@Input
        employee: EmployeeModel;
        //@Input
        identity: EmployeeIdentityResponse;
        //@Input
        roleAccess: CrudAccess;
        //@Input
        showPasswordEditor: boolean;
        //@Input
        separateEditPages: boolean;
        //@Output
        sendPasswordReset: EventEmitter<EmployeeModel>
        userID: number;
        sendUserPassword = false;
        editForm: IFormController;
        constructor(private $state: StateService, private employeeService: EmployeeService,
            private utilityService: UtilityService) {
            'ngInject';
        }

        $onInit() {
            this.userID = this.identity && this.identity.EmployeeID;
            this.sendUserPassword = true;

            if (!this.employeeForm) {
                // Note, employeeForm is the parent form, whereas editForm is the local form.
                window.onbeforeunload = () => {
                    if (this.editForm && this.editForm.$dirty) {
                        return "There are unsaved changes. Are you sure you want to abandon them?"
                    }
                }
            }
        }

        onChangeSendUserPassword() {
            // If unchecking, clear the password field.
            // Otherwise, clear the password to ensure that the user has to re-enter it.
            this.employee.Password = null;
        }

        onSave() {
            if (this.editForm && this.editForm.$invalid) {
                alert("Please fix any validation errors and try again.");
                return;
            }
            // Check if the user is changing their own username. This will corrupt the current session since
            // the user is identified by their username, so we will need to sign them out after.
            const requireSignOut = this.identity.EmployeeID === this.employee.Id
                && this.identity.UserName !== this.employee.UserName;
            if (requireSignOut && !confirm("You must be logged out of your current session in order to complete "
                + "this change. Please log in with the new user name to continue.")) {
                return;
            }
            const saving = this.employeeService.saveEmployee(this.employee as UpdateRosterEmployeeRequest);
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(saving, "Saving failed"));
            saving.then(() => {
                // Refresh data on this screen.
                this.$state.reload();
            }).catch(ex => {
                if (ex.status === 401 && requireSignOut) {
                    // Reload the page, which will redirect to the signin form.
                    window.location.reload();
                }
            })
        }
    }
}
